import { useMemo, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useItemsStore, useOrdersStore, useUIStore } from "../store";
import { useNavigationActions } from "./useNavigationActions";
import { useFindInMenu } from "./useFindInMenu";

export const useMainHomeLogic = () => {
  const { closeModal } = useNavigationActions();

  const setSection = useUIStore((s) => s.setSection);
  const section = useUIStore((s) => s.section);

  const orders = useOrdersStore((state) => state.orders);
  const menuData = useItemsStore((state) => state.menuData);
  const { findProduct } = useFindInMenu();

  const [searchParams] = useSearchParams();
  const productId = searchParams.get("product");
  const cartItemId = searchParams.get("cartItem");

  const isModalOpen = Boolean(productId || cartItemId);
  const wasModalOpen = useRef<boolean>(false);

  useEffect(() => {
    if (isModalOpen && !wasModalOpen.current) {
      wasModalOpen.current = true;
      setSection("productModal");
    }
    if (!isModalOpen && wasModalOpen.current) {
      wasModalOpen.current = false;
      if (section === "productModal") {
        setSection("home");
      }
    }
  }, [isModalOpen]);

  const plateToShow = useMemo(() => {
    if (!productId && !cartItemId) return null;

    const idToSearch = cartItemId
      ? orders.find((o) => o.cartItemId === cartItemId)?.productId
      : productId;

    if (!idToSearch) return null;

    return findProduct(idToSearch);
  }, [productId, cartItemId, orders, findProduct]);

  // Guardar último plate para que PlateModal no reciba null al cerrar
  const lastPlateRef = useRef<any>(null);
  if (plateToShow) lastPlateRef.current = plateToShow;

  const cartItemToEdit = useMemo(() => {
    if (!cartItemId) return undefined;
    return orders.find((o) => o.cartItemId === cartItemId);
  }, [cartItemId, orders]);


  const total = useMemo(
    () => orders.reduce((acc, item) => acc + item.quantity * item.price, 0),
    [orders]
  );

  return {
    menuData,
    orders,
    total,
    plateToShow: lastPlateRef.current,
    cartItemToEdit,
    isModalVisible: isModalOpen,
    isModalOpen,
    handleCloseModal: closeModal,
    section,
  };
};
